<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">お見積もりのご依頼</span>
              <span class="breadcrumb-link">お見積もりご依頼内容の確認</span>
              <span class="breadcrumb-link current">お見積もりご依頼の完了</span>
            </div>
            <h1 class="hdg02">お見積もりご依頼の完了</h1>
            <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>
          <div class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">お見積もり依頼の送信を完了しました。<br>
              ご入力いただいたメールアドレスにご依頼内容の確認メールを送信しておりますのでご確認ください。<br>
              弊社営業担当より3営業日以内にご連絡いたします。</p>
              
              <div class="contact-submit mb40">
                <div class="button contact-submit-button">
                  <router-link class="btn" to="/pc/login">ログイン画面へ</router-link>
                </div>
              </div>

              <div class="contact-content-info">
                <table class="contact-content-info-table">
                  <colgroup>
                    <col style="width:100px;">
                    <col style="width:100px;">
                  </colgroup>
                  <tr>
                    <th>申込内容</th>
                    <td>お見積もり</td>
                  </tr>
                  <tr>
                    <th>申込日</th>
                    <td>{{ group1.createdDisp }}</td>
                  </tr>
                </table>
                <!-- <div class="contact-content-info-number">申込No.1234567890</div> -->
              </div>

              <!-- PCの場合 -->
              <div class="visible-pc">

                <FontawesomeIcon v-if="!group1.isPackageAndLicensesLoaded" :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" />
                <template v-else>
                  <p v-if="group1.productsLicensesDisp.length === 0">表示する内容がありません。</p>
                  <template v-else>

                    <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" class="tbl04 box-package">
                      <div class="tbl04-hdgarea">
                        <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                      </div>
                      <div class="tbl04-bodyarea">

                        <table class="tbl04-table">
                          <colgroup>
                            <col style="width:55%;">
                            <col sytle="width:45%;">
                          </colgroup>
                          <thead>
                            <tr>
                              <th></th>
                              <th>見積もりライセンス数</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                              <th>
                                <div class="tbl04-table-txt">{{ item2.name }}</div>
                              </th>
                              <td>
                                <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                              </td>
                            </tr>
                            <tr v-for="(item3, index3) in item.option_products" :key="'option_' + index3">
                              <th class="pl40">
                                <div class="tbl04-table-txt">{{ item3.name }}</div>
                              </th>
                              <td>
                                <div class="tbl04-table-txt">{{ item3.license_number }}</div>
                              </td>
                            </tr>
                          </tbody>
                        </table>


                      </div>
                    </div>

                  </template>
                </template>

              </div>
              <!-- SPの場合 -->
              <div class="visible-sp">

                <FontawesomeIcon v-if="!group1.isPackageAndLicensesLoaded" :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" />
                <template v-else>
                  <p v-if="group1.productsLicensesDisp.length === 0">表示する内容がありません。</p>
                  <template v-else>

                    <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" class="tbl04">
                      <div class="tbl04-hdgarea">
                        <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                      </div>
                      <div class="tbl04-bodyarea">

                        <table class="tbl04-table">
                          <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                            <td>
                              <div class="tbl04-table-txt">{{ item2.name }}</div>
                            </td>
                            <th>見積もりライセンス数</th>
                            <td>
                              <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                            </td>
                          </tr>
                        </table>
                        <template v-if="item.option_products.length > 0">
                          <div class="tbl04-bodyarea-hdg">
                            <h4 class="hdg04">オプション</h4>
                          </div>
                          <table class="tbl04-table">
                            <tr v-for="(item3, index3) in item.option_products" :key="'option_' + index3">
                              <td>
                                <div class="tbl04-table-txt">{{ item3.name }}</div>
                              </td>
                              <th>見積もりライセンス数</th>
                              <td>
                                <div class="tbl04-table-txt">{{ item3.license_number }}</div>
                              </td>
                            </tr>
                          </table>
                        </template>

                      </div>
                    </div>

                  </template>
                </template>

              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'
import * as logicEstimate from '@/logic/public/Estimate'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicEstimate.getGroupComplete(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.box-package{
  border: 1px solid #ddd;
  border-radius: 5px;
  & + .box-package{
    margin-top: 50px;
  }
  .tbl04-hdgarea{
    border-top: none;
  }
  .tbl04-bodyarea{
    border-bottom: none;
  }
  & + .contact-submit{
    margin-top: 30px;
  }
}
</style>
